var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center min-h-[120px] font-medium text-white-500 text-[1.1rem]"},[_vm._t("default",function(){return [_vm._v("No Data")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }